$(document).on('click', 'a[href^="#"]', function()
{
    //event.preventDefault();
    var speed = 500;
    var href= $(this).attr("href");
    if(href == "#top")
    {
      var position = 0;
      $('body,html').stop().animate({scrollTop:position}, speed, 'linear');
    }
    else
    {
      if($(this).parent().hasClass('cf-reset-password')) {
        return true;
      }
      if(href != '#recover' && href != '#login') {
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $('body,html').stop().animate({scrollTop:position}, speed, 'linear');
        return false;
      }
    }
});

$(window).on('load resize', function(){
  closeFixedMenu(false);

  if(isDesktop()){
    /* header-search */
    if($(window).width() > 1200){
      var tmp = ($(window).width() - 1200) / 2;
      $('#header .header-search').css('padding-left', tmp+'px');
    } else {
      $('#header .header-search').css('padding-left', '0');
    }
    /* gmenu */
    $('#header #gmenu').removeAttr('style');
    $('#header #gmenu').css('display', 'block');
    $('#header #gmenu .category-list .gmenu-list').css('display', 'none');
  } else {
    $('#header .header-search').css('padding-left', '10px');
    $('#header .fixed-header-search').removeAttr('style');

    /* gmenu */
    $('#header #gmenu .category-list .gmenu-list').removeAttr('style');
  }

  adjustItemlistData('#item-area .item-list > li');

});

$(window).on('load', function(){
  $('form#customer_login').submit(function() {
    if($('input[name=rid]').prop('checked')){
      setCookie('s', $('form#customer_login input[name="customer[email]"]').val(), 30, '/');
    } else {
      setCookie('s', '', -1, '/');
    }
  });

  $('.mainBanner2 .slides').slick({
    dots: true,
    infinite: true,
    speed: 300,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    autoplay: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    //prevArrow:'<p class="btn_prev ctrl-dir"><span><img src="/cdn/shop/files/ico_arrow_prev.png"></span></p>',
    //nextArrow:'<p class="btn_next ctrl-dir"><span><img src="/cdn/shop/files/ico_arrow_next.png"></span></p>',
    responsive:[
      {
        breakpoint:1201,
        settings:{
          arrows: false,
          centerMode: false,
          variableWidth : false
        }
      }
    ]
  });
  if($('.pagenav').length){
    $('.pagenav').appendTo('main .tit-main .wrap_');
  }

  if($('#price-slider').length) {
    $('#price-slider').slider({
      min: 0,
      max: 100000,
      step: 1000,
      values: [3000, 50000],
      change: function(e, ui) {
        $('#price1_val').val(separate(ui.values[0]));
        $('#price2_val').val(separate(ui.values[1]));
        $("input[name='filter.v.price.gte']").val(ui.values[0]);
        $("input[name='filter.v.price.lte']").val(ui.values[1]);
      },
      create: function(e, ui) {
        $('#price1_val').val(separate($(this).slider('values', 0)));
        $('#price2_val').val(separate($(this).slider('values', 1)));
        $("input[name='filter.v.price.gte']").val($(this).slider('values', 0));
        $("input[name='filter.v.price.lte']").val($(this).slider('values', 1));
      }
    });
  }
  $('.detail-search-sub .cur').on('click', function(){
    $(this).siblings('ul').stop().slideToggle();
  });
  $('.top-area .detail-search .btn-area').on('click', function(){
    $(this).siblings('.search-contents').stop().slideToggle();
    $(this).toggleClass('on');
  });

  $('.zoomy').each(function(index, el) {
    $(this).wrap('<span style="display: inline-block;"></span>').css('display', 'block').parent().zoom({
      url:$(this).data('large-img-url')
    });
  });

  var mainImg_view_pc = $('main .img-area .slides.onlyPC').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow:'<p class="btn_prev ctrl-dir"><img src="/cdn/shop/files/ico_arrow_prev.png"></p>',
    nextArrow:'<p class="btn_next ctrl-dir"><img src="/cdn/shop/files/ico_arrow_next.png"></p>'
  });
  $('main .img-area .slides.onlySP').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('main .img-area .pager span').text(nextSlide+1);
  });
  var mainImg_view_sp = $('main .img-area .slides.onlySP').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    prevArrow:'<p class="btn_prev ctrl-dir"><img src="/cdn/shop/files/ico_arrow_prev.png"></p>',
    nextArrow:'<p class="btn_next ctrl-dir"><img src="/cdn/shop/files/ico_arrow_next.png"></p>'
  });
  $('.thumb li').on('click', function(event) {
    event.preventDefault();
    slideIndex = $(this).index();
    mainImg_view_pc.slick('slickGoTo', parseInt(slideIndex));
    mainImg_view_sp.slick('slickGoTo', parseInt(slideIndex));
  });
});

$(window).on('scroll', function(){
  if(isDesktop() && $(this).scrollTop() > 150){
    $('#header').addClass('fixed');
    $('main').css('padding-top', '200px');
  } else {
    $('#header').removeClass('fixed');
    $('main').css('padding-top', '0');
  }

  var footerTopPos = $('#footer').offset().top;
  var scrllPos = $(window).height() + $(window).scrollTop();
  if(scrllPos >= footerTopPos){
    $('#footer #pagetop').addClass('absolute');
  } else{
    $('#footer #pagetop').removeClass('absolute');
  }
});

/* PC gmenu */
$('#header #gmenu .category-list').hover(
  function(){
    if(isDesktop()){
      $(this).find('.gmenu-list').stop().slideDown();
    }
  },
  function(){
    if(isDesktop()){
      $(this).find('.gmenu-list').stop().slideUp();
    }
  }
);


/* SP FixedMenu */
$('#header .menu .menu-btn').on('click', function(){
  $('#header #gmenu .category-list .gmenu-list').css('display', 'block');
  $('#header .menu .menu-btn').css('display', 'none');
  $('#header .menu .close-btn').css('display', 'flex');
  $('#overlay-header').css('display', 'block');
  $('#header #gmenu').stop().slideDown();
});

function closeFixedMenu(isSlide){
  $('#header .menu .menu-btn').css('display', 'block');
  $('#header .menu .close-btn').css('display', 'none');
  $('#overlay-header').css('display', 'none');
  if(isSlide){
    $('#header #gmenu').stop().slideUp();
  } else {
    $('#header #gmenu').css('display', 'none');
  }
};

/* PC fixed-header-search */
function showHeaderSearch(){
  var maxWidth = $('#header .header-search#default').width();
  $('#header .fixed-header-search .btn-search-area').css('display', 'none');
  $('#header .fixed-header-search .header-search').width(0);
  $('#header .fixed-header-search .header-search').css('display', 'block');
  $('#header .fixed-header-search .header-search').stop().animate({
    'width' : maxWidth+'px'
  }, 200, function(){
    $(this).addClass('show');
  })
}
function hideHeaderSearch(){
  $('#header .fixed-header-search .header-search').removeClass('show')
  $('#header .fixed-header-search .header-search').stop().animate({
    'width' : 0+'px'
  }, 200, function(){
    $('#header .fixed-header-search .header-search').css('display', 'none');
    $('#header .fixed-header-search .btn-search-area').css('display', 'block');
  });
}

// ==================================================================
// isDesktop
// ==================================================================
function isDesktop(){
  if($(window).width() >=  835){
    return true;
  } else {
    return false;
  }
}

// ==================================================================
// form
// ==================================================================
function submitForm(formid){
	$('#'+formid).submit();
}

// ==================================================================
// 数字3桁くぎり
// ==================================================================
function separate(num){
  num = String(num);
  var len = num.length;
  if(len > 3){
      return separate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
  } else {
      return num;
  }
}

/*****************************************************************
  itemlist name Height
*****************************************************************/
function adjustItemlistData(obj){
  $(obj).each(function(index, el) {
    $(this).find('.name').css('height', 'auto');
  });

  var colNum = 2;
  if(isDesktop()){
    colNum = 4;
  }
  var colCount = 0;
  var elmArry = [];
  var elmHeight = 0;
  $(obj).each(function(index, el) {
    elmArry.push($(this));
    var tmp = Math.max(elmHeight, $(this).find('.name').height());
    elmHeight = tmp;
    ++colCount;

    if(colCount >= colNum){
      setItemlistHeight(elmArry, elmHeight);
      colCount = 0;
      elmHeight = 0;
      elmArry.length = 0;
    }
  });
  setItemlistHeight(elmArry, elmHeight);
}

function setItemlistHeight(arry, height){
  $.each(arry, function(index, value){
    value.find('.name').height(height);
  });
}

/*****************************************************************
  getAjaxData
*****************************************************************/
function getAjaxData(url, dOptions){
  var ajaxdataDeferred = new $.Deferred();

  return $.ajax({
    type: 'GET',
    async: true,
    url:  url,
    dataType : 'html',
    data: dOptions,
    timeout : 10000,
  }).done(function(data, dataType, status, xhr) {
    ajaxdataDeferred.resolve(data);
  }).fail(function(XHR, status, errorThrown) {
  }).always(function(){
  });
  return ajaxdataDeferred.promise();
}

// ==================================================================
//
// cookie
//
// ==================================================================
function setCookie(c,v,e,p)
{
    var extime = new Date().getTime();
    var cltime = new Date(extime + (60*60*24*1000*e));
    var exdate = cltime.toUTCString();
    var s = "";
    s += c +"="+ encodeURIComponent(v);
    s += "; p="+ p;
    if(e) s += "; expires=" +exdate+"; ";
    else s += "; ";
    if(p) s += "; path=" +p+"; ";
    else s += "; ";
    document.cookie=s;
}

function readCookie(cookieName)
{
  if (document.cookie) {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      var str = cookies[i].split("=");
      if (str[0] == cookieName) {
        var cookie_value = decodeURIComponent(str[1]);
        break;
      }
    }
    return cookie_value;
  } else {
    return "";
  }
}

/*****************************************************************
  commonModal
*****************************************************************/
function showModal(contentsID){
  $('#'+contentsID).addClass('c-modal on');
  $('#'+contentsID).stop().fadeIn();
  $('body').append('<div id="modal-overlay"></div>');
}
function closeModal(){
  $('.c-modal.on').each(function(index, el) {
    $(this).stop().fadeOut();
    $(this).removeClass('on');
  });
  $('#modal-overlay').remove();
}
$(document).on('click', '#modal-overlay' , function() {
  closeModal();
});


const localViewed = localStorage.recentlyViewedProduct;
function getSimpleRecentlyViewedProducts(num) {
  let simpleRecentlyViewedProduct = JSON.parse(localViewed);
  let productData = [];
  for (var i = 0;  i < num;  i++) {
    productData.push(simpleRecentlyViewedProduct[i]);
  }
  let simpleRecentlyViewedHtml = [];
  productData.map(item => {
    simpleRecentlyViewedHtml.unshift(`
      <li>
        <a href="${item.productUrl}">
          <div class="img"><img src="${item.productImg}" alt="${item.productImageAltText}" width="100%" height="" loading="lazy"></div>
          <div class="ico-brand"><img src="/cdn/shop/files/ico_${item.productVendor}_off.png" alt="${item.productVendor}" width="" height="" loading="lazy"></div>
          <div class="data">
            <p class="name">${item.productTitle}</p>
            <p class="price">${item.productPrice}</p>
          </div>
        </a>
      </li>
    `);
  });
  let simpleRecentlyViewedData = `${simpleRecentlyViewedHtml.join("")}`;
  const simpleRecentlyViewedTarget = document.getElementsByClassName("simple-recently-viewed-grid");

  if(simpleRecentlyViewedData == '') {
    document.getElementsByClassName("simple-recently-viewed-wrapper")[0].style.display = 'none';
  } else {
    simpleRecentlyViewedTarget[0].innerHTML = simpleRecentlyViewedData;
  }
}

// function graphqlapiCall(query) {
//   return fetch('https://dealer-store-bridgestonesports-weex.myshopify.com/api/2023-07/graphql.json', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/graphql',
//       'X-Shopify-Storefront-Access-Token': ""
//     },
//     'body': query
//   }).then(response => response.json());
// }